import type { Utility } from '../../../types/utility';
import { breakpoints } from '../../breakpoints';
import type { LogoSection } from './index';

const baseVariantShared: Utility.CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  listStyle: 'none',
  rowGap: 's64',
  columnGap: 's48',
  justifyContent: 'center',
  width: '100%',
  marginLeft: 0,
  '& > li': {
    flexBasis: 'calc(50% - 48px)',
    maxHeight: '104px',
    minWidth: '70px',
    display: 'flex',
    alignItems: 'center',
  },
  [breakpoints.bp768.min]: {
    columnGap: 's64',
    '& > li': {
      maxHeight: 'none',
      flexGrow: 0,
      flexShrink: 1,
      flexBasis: 'calc(33% - 64px)',
    },
  },
  [breakpoints.bp1024.min]: {
    rowGap: 's80',
    columnGap: 's80',
  },
};

const baselayouts: Utility.VariantCSSKeys<LogoSection.Layout.VariantKeys> = {
  default: baseVariantShared,
  oneLine: {
    ...baseVariantShared,
    [breakpoints.bp1024.min]: {
      flexWrap: 'nowrap',
    },
  },
  threeWrap: {
    ...baseVariantShared,
    [breakpoints.bp768.min]: {
      '& > li': {
        flexBasis: 'calc(33.33% - 64px)',
        margin: '0 32px',
      },
    },
  },
  fiveWrap: {
    ...baseVariantShared,
    [breakpoints.bp1024.min]: {
      '& > li': {
        flexBasis: 'calc(20% - 64px)',
        margin: '0 32px',
      },
    },
  },
  carousel: {
    display: 'block',
    whiteSpace: 'nowrap',
    listStyle: 'none',
    width: 'max-content',
    marginLeft: 0,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    '&:nth-of-type(2)': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      margin: 0,
    },
    '& > li': {
      display: 'inline-block',
      margin: '0 45px',
      width: '150px',
      '& img': {
        verticalAlign: 'middle',
      },
    },
  },
};

const layout: Utility.VariantKeyModes<LogoSection.Layout.VariantKeys> = {
  products: {
    chart: baselayouts,
    chartblog: baselayouts,
    co: baselayouts,
    edu: baselayouts,
    scale: baselayouts,
    spark: baselayouts,
  },
};

export const layoutVariants = Object.keys(layout) as LogoSection.Layout.VariantKeys[];

export default layout;
